module.exports = __webpack_public_path__ + "fonts/Flaticon.e9b331dd.woff";